import { matchPath } from 'react-router-dom'
import type { ReactNode } from 'react'

export interface KeptTab {
  path: string
  element: ReactNode
}

export function activeTabPath(tabs: readonly KeptTab[], pathname: string): string | undefined {
  return tabs.find(t => matchPath(t.path, pathname))?.path
}
